import React, {useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import {
  selectOrderCustomerId,
  selectOrderShippingAddress,
  setChangeShippingAddress,
} from 'app/features/orders/redux/order/orderEditSlice'
import CustomerAddressDialog from 'app/features/orders/orderEdit/edit/components/Address/CustomerAddressDialog'
import SelectShippingRateDialog from './SelectShippingRateDialog'
import CustomShipRateDialog from './CustomShipRateDialog'

const initialState = Object.freeze({
  shippingAddress: false,
  customRate: false,
})

interface Props {
  onClose: () => void
}

export const ShippingMethodDialog: React.FC<Props> = ({onClose}) => {
  const dispatch = useDispatch()
  const [dialog, setDialog] = useState<any>(initialState)
  const customerId = useSelector<RootState>(selectOrderCustomerId) as any
  const shippingAddress = useSelector<RootState, any>(selectOrderShippingAddress)

  return useMemo(() => {
    const handleAddressChange = (address: any) => {
      dispatch(setChangeShippingAddress(address))
      handleCloseAddress()
    }

    const handleOpenAddress = () => {
      setDialog({...dialog, shippingAddress: true})
    }

    const handleCloseAddress = () => {
      setDialog({...dialog, shippingAddress: false})
    }

    const handleOpenCustomRate = () => {
      setDialog({...dialog, customRate: true})
    }

    const handleCloseCustomRate = () => {
      setDialog({...dialog, customRate: false})
      onClose()
    }

    if (dialog.shippingAddress) {
      return (
        <CustomerAddressDialog
          onClose={handleCloseAddress}
          customerId={customerId}
          selectedAddress={shippingAddress?.id}
          onChangeAddress={handleAddressChange}
        />
      )
    } else if (dialog.customRate) {
      return <CustomShipRateDialog onCloseCustomRate={handleCloseCustomRate} onClose={onClose} />
    }
    return (
      <SelectShippingRateDialog
        onCloseEditRate={onClose}
        onOpenAddress={handleOpenAddress}
        onCustomRateOpen={handleOpenCustomRate}
      />
    )
  }, [customerId, dialog, dispatch, shippingAddress?.id, onClose])
}

export default ShippingMethodDialog
